import { DangerousTranslate } from '~/components/DangerousTranslate'
import { GT } from '~/lib/gt'

const PRIVACY_POLICY_URL = `${process.env.NEXT_PUBLIC_DE_CLUB_URL}/privacy-policy`

const marketingConsent = (gt: GT) => ({
  label: (
    <DangerousTranslate
      text={gt.tp(
        'RegisterForm',
        'Yes, I would like to receive promotional messages from RCD RestaurantClub GmbH with discount codes as well as information about upcoming Festivals, Festival partners, participating restaurants, menus, promotions and special offers via email, SMS or post and agree that my contact data will be processed in accordance with the <a href="{{ privacyPolicyLink }}" target="_blank">Privacy Policy</a>, including tracking and profiling measures.',
        { privacyPolicyLink: PRIVACY_POLICY_URL }
      )}
    />
  ),
  showMore: (
    <DangerousTranslate
      text={gt.tp(
        'RegisterForm',
        'I can withdraw my consent at any time without giving reasons. For this purpose, an email to info@restaurant-week.de or clicking the unsubscribe link placed at the end of each newsletter is sufficient. No costs other than transmission costs according to basic rates will be incurred. The withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal.'
      )}
    />
  ),
})

export const getCopy = (gt: GT) => ({
  marketingConsent: marketingConsent(gt),
})
